const indexItems = [
  { title: '韩漫精选', count: '326部', icon: 'ri-earth-line', color: 'bg-primary-100/70 text-primary-700' },
  { title: '日漫经典', count: '518部', icon: 'ri-global-line', color: 'bg-accent-100/70 text-accent-700' },
  { title: '国漫专区', count: '289部', icon: 'ri-map-pin-line', color: 'bg-secondary-100/70 text-secondary-700' },
  { title: '热血格斗', count: '142部', icon: 'ri-boxing-line', color: 'bg-primary-100/70 text-primary-700' },
  { title: '恋爱甜宠', count: '203部', icon: 'ri-heart-2-line', color: 'bg-accent-100/70 text-accent-700' },
  { title: '悬疑推理', count: '97部', icon: 'ri-search-eye-line', color: 'bg-secondary-100/70 text-secondary-700' },
  { title: '穿越重生', count: '168部', icon: 'ri-loop-left-line', color: 'bg-primary-100/70 text-primary-700' },
  { title: '系统升级', count: '85部', icon: 'ri-cpu-line', color: 'bg-accent-100/70 text-accent-700' },
  { title: '完结全集', count: '412部', icon: 'ri-checkbox-circle-line', color: 'bg-secondary-100/70 text-secondary-700' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">专题合集</h2>
          <p className="text-foreground-500 text-sm mt-2">按类型快速找到你想看的漫画</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4">
          {indexItems.map((item) => (
            <div
              key={item.title}
              className={`flex items-center gap-4 p-5 rounded-xl ${item.color} cursor-pointer hover:scale-[1.02] transition-transform duration-200`}
            >
              <div className="w-11 h-11 rounded-lg bg-background-50/80 flex items-center justify-center">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold">{item.title}</h3>
                <p className="text-xs opacity-70 mt-0.5">{item.count}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}